import type { BuilderPricingVisibilitySettings } from "api-types/builders/builderTypes";

export const defaultPricingVisibilitySettings: BuilderPricingVisibilitySettings = {
  communityPlans: false,
  internalHomePlanLinks: false,
  publicHomePlanLinks: false,
  optionSummary: false,
  salesBrochure: false,
  publicSalesMap: false,
};

export const pricingVisibilitySettings: {
  [key in keyof BuilderPricingVisibilitySettings]: { label: string; description: string };
} = {
  communityPlans: {
    label: "Community Plans",
    description: "Display prices in community plans",
  },
  internalHomePlanLinks: {
    label: "Internal Location and Home Plan Links",
    description: "Display prices in internal location and home plan links",
  },
  publicHomePlanLinks: {
    label: "Public Location and Home Plan Links",
    description: "Display prices in public location and home plan links",
  },
  optionSummary: {
    label: "Option Summary",
    description: "Display plan and option pricing in the option summary page on home plans",
  },
  salesBrochure: {
    label: "Sales Brochure",
    description: "If Options Page is enabled, display the price of each configured option in the sales brochure",
  },
  publicSalesMap: {
    label: "Lot Premiums on Public Sales Map",
    description: "Display lot premiums on the public sales map",
  },
};
